// extracted by mini-css-extract-plugin
export default {"tooltip":"DateTooltip_tooltip__OqYS5","row":"DateTooltip_row__--WiS","label":"DateTooltip_label__mPGw8","value":"DateTooltip_value__0RZ27","separator":"DateTooltip_separator__3FZmZ"};